// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"124385085f6a3ffb2de8","655":"33f0037ced2fda4fb6b0"}[chunkId] + ".js";
};